import { useEffect, useState } from "react";
import { LifeBuoy, Loader2, Plus } from "lucide-react";
import { toast } from "sonner";
import { PageHeader, Spinner, Card, EmptyState } from "@/components/dash";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import api, { apiErr } from "@/lib/api";
import { formatDate } from "@/lib/format";

export default function Support() {
  const [tickets, setTickets] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ subject: "", message: "" });
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/support/tickets").then(({ data }) => setTickets(data.tickets)).catch(() => setTickets([]));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try { await api.post("/support/tickets", form); toast.success("Destek talebi oluşturuldu."); setOpen(false); setForm({ subject: "", message: "" }); load(); }
    catch (err) { toast.error(apiErr(err)); } finally { setSaving(false); }
  };

  return (
    <div>
      <PageHeader title="Destek" desc="Sorularınız için destek talebi oluşturun."
        action={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button data-testid="new-ticket-btn" className="rounded-full"><Plus size={16} /> Yeni Talep</Button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Destek Talebi</DialogTitle></DialogHeader>
              <form onSubmit={submit} className="space-y-4">
                <div><Label className="text-sm">Konu</Label><Input required value={form.subject} onChange={(e) => setForm((f) => ({ ...f, subject: e.target.value }))} data-testid="ticket-subject" className="mt-1.5" /></div>
                <div><Label className="text-sm">Mesajınız</Label><Textarea required value={form.message} onChange={(e) => setForm((f) => ({ ...f, message: e.target.value }))} data-testid="ticket-message" className="mt-1.5 min-h-28" /></div>
                <Button type="submit" disabled={saving} className="w-full rounded-full">{saving ? <Loader2 className="animate-spin" size={16} /> : "Gönder"}</Button>
              </form>
            </DialogContent>
          </Dialog>
        }
      />
      {tickets === null ? <Spinner /> : tickets.length === 0 ? (
        <EmptyState icon={LifeBuoy} title="Henüz destek talebi yok" desc="Yardıma mı ihtiyacınız var? Yeni bir talep oluşturun." />
      ) : (
        <div className="space-y-3">
          {tickets.map((t) => (
            <Card key={t.id} className="p-4">
              <div className="flex items-center justify-between">
                <p className="font-semibold">{t.subject}</p>
                <span className={`text-xs px-2 py-0.5 rounded-full ${t.status === "open" ? "bg-amber-500/10 text-amber-500" : "bg-muted text-muted-foreground"}`}>{t.status === "open" ? "Açık" : "Kapalı"}</span>
              </div>
              <p className="mt-1.5 text-sm text-muted-foreground">{t.message}</p>
              <p className="mt-2 text-xs text-muted-foreground">{formatDate(t.created_at)}</p>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
